/* eslint-disable */
import React, { useContext } from 'react';
import { Data, Filters } from '../contexts';
import { parseMoney } from '../../utils';
import { CommonSizeArrowsHelper, MonthlyPNLandBalValues, MonthlyNAICSFocusedVals } from '../report_components/MoneyHelpers';

const MonthlyHistoricTable = ({ clientName, editMetrics, handleEditMetrics, handleSelectAndLayout, rows, sheet, ...props }) => {
  const { monthly_calcs, trailing12 } = useContext(Data);
  const { filters } = useContext(Filters);
  let finalFilters = props.tabFilters || filters;
  const monthlyCalcs = finalFilters.report_period === 'Trailing 12' ? trailing12 : monthly_calcs;
  const avgCalcs = props.aggregateData && finalFilters.report_period === 'Trailing 12' ? props.aggregateData?.trailing12?.avg : props.aggregateData ? props.aggregateData?.monthly?.avg : monthlyCalcs?.avg;
  const docsAvgCalcs = props.aggregateData && finalFilters.report_period === 'Trailing 12' ? props.aggregateData?.trailing12?.docs_avg : props.aggregateData ? props.aggregateData?.monthly?.docs_avg : monthlyCalcs?.docs_avg;
  const selectedYear = finalFilters['year']
  const previousYear = finalFilters['year'] - 1
  const compareWith = finalFilters.compare_with;
  const endMonthOfSelectedYear = finalFilters.date_through_monthly_month && finalFilters.date_through_monthly_year ? Number(finalFilters.date_through_monthly_month) : 12;

  let numberCompare;
  if ((finalFilters && compareWith === 'Default:YOY') || (compareWith && compareWith.includes("Forecast"))) {
    numberCompare = 'n = 1'
  } else {
    const numOfPeers = props.page === 'docs_pnl'
      ? (props.aggregateData?.monthly_docs_avg_n?.[selectedYear] ?? 0)
      : (props.aggregateData?.monthly_avg_n?.[selectedYear] ?? 0);
    numberCompare = `n = ${numOfPeers}`;
  }
  const monthNames = Object.values(props.monthsObj);
  let monthsAvailable = 0;
  const arrowCellClass = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow';
  const commonSizeValCellClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';
  const useableMonths = monthlyCalcs?.you?.cash?.[selectedYear] ? Object.values(monthlyCalcs?.you?.cash?.[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
  useableMonths.forEach((thing) => (thing !== null ? (monthsAvailable += 1) : null));

  const buildEmptyRow = (
    i,
    key = '',
    copy = '',
    relatedCheckedKey,
    padding = '',
    checked,
    displayChart,
    copyRowStyle,
    copyCellStyle,
  ) => {
    if (copy === 'Current Liabilities') {
      copyRowStyle.paddingTop = '20px';
    }
    copyRowStyle.height =
      props.page === 'docs_pnl' || key === 'space_before_revenue' ? '20px' : '';
    const rowChecked =
      displayChart && checked && editMetrics && props.page === 'money' ? (
        <p style={{ margin: 0 }}>&#10004;</p>
      ) : (
        ''
      );

    return (
      <tr
        key={`${i}-empty-${copy}`}
        onClick={() =>
          editMetrics ? handleSelectAndLayout('money', sheet, relatedCheckedKey) : null
        }
      >
        {props.page === 'money' && !props.pdf ? <td>{rowChecked}</td> : null}
        <td className={copyCellStyle} style={copyRowStyle}>
          {padding + copy}
        </td>
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className="table-copy" style={copyRowStyle} />
        <td className={commonSizeValCellClass} style={copyRowStyle} />
        {compareWith === 'Default:None' ? null : (
          <td className={arrowCellClass} style={copyRowStyle} />
        )}
        {(compareWith && compareWith.includes('Forecast')) || finalFilters.report_period === 'Trailing 12' ? (
          <td className={commonSizeValCellClass} style={copyRowStyle} />
        ) : null}
        {compareWith === 'Default:None' ? null : (
          <td className={commonSizeValCellClass} style={copyRowStyle} />
        )}
      </tr>
    );
  };

  function Total(props) {
    const style = { ...props.style, fontWeight: 'bold' };
    if (props.array.length === 0) {
      return <td style={style} />;
    }
    if (props.sheet == 'pnl') {
      return <td style={style}>{parseMoney(props.array.reduce((a, b) => a + b, 0))}</td>;
    }
    return <td style={style}>{parseMoney(props.array[monthsAvailable - 1])}</td>;
  }

  function MonthlyCommonSized(props) {
    if (props.array.length === 0) {
      return <td className={commonSizeValCellClass} style={props.style} />;
    }
    if (props.sheet == 'pnl') {
      const reducedArray = props.array.slice(0, monthsAvailable).reduce((a, b) => a + b, 0);

      if (_.isNumber(reducedArray) && !_.isEmpty(props.passedCalcs)) {
        const totalRevenue = Object.values(props.passedCalcs.total_revenue[props.selectedYear])
          .slice(0, monthsAvailable)
          .reduce((a, b) => a + b, 0);

        return (
          <td className={commonSizeValCellClass} style={props.style}>
            {`${((reducedArray / totalRevenue) * 100).toFixed(2)}%`}
          </td>
        );
      }
      return (
        <td className={commonSizeValCellClass} style={props.style}>
          -
        </td>
      );
    }
    const totalAssets = Object.values(props.passedCalcs.total_assets[props.selectedYear]).filter((val) =>
      _.isNumber(val),
    );
    const totalAssetsValue = totalAssets.length > 0 ? totalAssets[monthsAvailable - 1] : null;

    if (_.isNumber(props.array[0]) && _.isNumber(totalAssetsValue)) {
      const lastValue = totalAssets.length > 0 ? props.array[monthsAvailable - 1] : null;

      return (
        <td className={commonSizeValCellClass} style={props.style}>
          {`${((lastValue / totalAssetsValue) * 100).toFixed(2)}%`}
        </td>
      );
    }
    return (
      <td className={commonSizeValCellClass} style={props.style}>
        -
      </td>
    );
  }

  const buildRow = ({ i = '', header = '', header_is_total = false, header_key = '', key = '', copy = '', padding = '', bold = '', forecast = true, checked = false, displayChart = false, relatedCheckedKey = '', map_keys = [], emptyRow = false, topline = '', whiteSpace = '', alwaysDisplayRow = false }) => {
    let passedCalcs = {}
    let underlineFormat, boldFont, valueArr;
    let compareValueArr = [];
    const zeroMonths = [];
    let toplineFormat = topline ? 'solid 1px' : '';
    let compareSelectedYear = selectedYear;

    if (compareWith === 'Default:Peers') {
      passedCalcs = avgCalcs;
    } else if (compareWith === 'Default:YOY') {
      passedCalcs = monthlyCalcs?.you;
      compareSelectedYear = previousYear
    } else if (compareWith && compareWith.includes('Forecast')) {
      passedCalcs = props.forecastVals;
      compareSelectedYear = props.forecastVals?.['total_revenue'] ? Object.keys(props.forecastVals['total_revenue'])[0] : null
    }

    if (forecast) {
      if (forecast.total) {
        if (forecast.total.boldedUnderline) {
          underlineFormat = 'solid 2px';
        } else if (forecast.total.doubleUnderline) {
          underlineFormat = 'double 2px';
        } else if (forecast.total.underline) {
          underlineFormat = 'solid 1px';
        }

        toplineFormat = forecast.total.topline ? 'solid 1px' : '';
      } else {
        if (forecast.boldedUnderline) {
          underlineFormat = 'solid 2px';
        } else if (forecast.doubleUnderline) {
          underlineFormat = 'double 2px';
        } else if (forecast.underline) {
          underlineFormat = 'solid 1px';
        }

        boldFont = bold || forecast.bold ? 'bold' : '';
        toplineFormat = forecast.topline ? 'solid 1px' : '';
      }
    }

    const copyRowStyle = {
      fontWeight: boldFont,
      textAlign: 'left',
      borderBottom: underlineFormat,
      borderTop: toplineFormat,
    };

    const copyCellStyle = whiteSpace ? 'table-copy wrap-copy-cell' : 'table-copy';

    const valueStyle = {
      textAlign: 'right',
      borderBottom: underlineFormat,
      borderTop: toplineFormat ? 'solid 1px' : '',
    };

    if (
      (header && header_is_total == false) ||
      (header_key && header_is_total == false) ||
      (emptyRow && header_is_total == false) ||
      emptyRow
    )
      return buildEmptyRow(
        i,
        key,
        copy,
        relatedCheckedKey,
        padding,
        checked,
        displayChart,
        copyRowStyle,
        copyCellStyle,
      );

    if (props.page === 'docs_pnl') {
      valueArr = MonthlyNAICSFocusedVals(
        props.naicsCode,
        monthsAvailable,
        key,
        map_keys,
        selectedYear,
        monthlyCalcs?.you,
        rows,
      );

      if (compareWith === 'Default:Peers') {
        compareValueArr = MonthlyNAICSFocusedVals(
          props.naicsCode,
          monthsAvailable,
          key,
          map_keys,
          selectedYear,
          docsAvgCalcs,
          rows,
        );
        passedCalcs = docsAvgCalcs;
      } else if (compareWith === 'Default:YOY') {
        compareValueArr = MonthlyNAICSFocusedVals(
          props.naicsCode,
          monthsAvailable,
          key,
          map_keys,
          compareSelectedYear,
          monthlyCalcs?.you,
          rows,
        );
        passedCalcs = monthlyCalcs?.you;
      } else if (compareWith && compareWith.includes('Forecast')) {
        compareValueArr = MonthlyNAICSFocusedVals(
          props.naicsCode,
          monthsAvailable,
          key,
          map_keys,
          compareSelectedYear,
          props.forecastVals,
          rows,
        );
        passedCalcs = props.forecastVals;
      }
    } else {
      const you = monthlyCalcs ? monthlyCalcs?.you?.[key]?.[selectedYear] : undefined;
      const avg = avgCalcs && avgCalcs?.[key] ? avgCalcs?.[key]?.[selectedYear] : undefined;
      const yoy = monthlyCalcs ? monthlyCalcs?.you?.[key]?.[previousYear] : undefined;

      valueArr = MonthlyPNLandBalValues(monthsAvailable, sheet, key, you, selectedYear, monthlyCalcs?.you);

      if (compareWith === 'Default:Peers') {
        compareValueArr = MonthlyPNLandBalValues(
          monthsAvailable,
          sheet,
          key,
          avg,
          selectedYear,
          avgCalcs,
        );
      } else if (compareWith === 'Default:YOY') {
        compareValueArr = MonthlyPNLandBalValues(monthsAvailable, sheet, key, yoy, compareSelectedYear, monthlyCalcs?.you);
      } else if (compareWith && compareWith.includes('Forecast')) {
        const forecast = props.forecastVals?.[key] ? props.forecastVals?.[key]?.[compareSelectedYear] : undefined;
        compareValueArr = MonthlyPNLandBalValues(
          monthsAvailable,
          sheet,
          key,
          forecast,
          compareSelectedYear,
          props.forecastVals,
        );
      }
    }

    for (let i = 0; i < monthsAvailable + 1; i++) {
      valueArr[i] === 0 && compareValueArr.reduce((a, b) => a + b, 0) === 0
        ? zeroMonths.push(i)
        : null;
    }
    const hideRow = zeroMonths.length === monthsAvailable && !alwaysDisplayRow ? copy : null;
    const rowStyle = copy === hideRow && !alwaysDisplayRow ? { display: 'none' } : {};
    const rowChecked =
      displayChart && checked && editMetrics && props.page === 'money' ? (
        <p style={{ margin: 0 }}>&#10004;</p>
      ) : (
        ''
      );

    return (
      <tr
        id={`${sheet}-report-row-${i}`}
        key={`${sheet}-report-row-${key}-${i}`}
        style={rowStyle}
        onClick={() =>
          editMetrics ? handleSelectAndLayout('money', sheet, relatedCheckedKey) : null
        }
      >
        {props.page === 'money' && !props.pdf ? <td>{rowChecked}</td> : null}
        <td className={copyCellStyle} style={copyRowStyle}>
          {padding + copy}
        </td>
        <td style={valueStyle}>{parseMoney(valueArr[0])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[1])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[2])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[3])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[4])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[5])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[6])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[7])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[8])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[9])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[10])}</td>
        <td style={valueStyle}>{parseMoney(valueArr[11])}</td>
        <Total array={valueArr} style={valueStyle} sheet={sheet} />
        <MonthlyCommonSized
          array={valueArr}
          metricKey={key}
          style={valueStyle}
          sheet={sheet}
          selectedYear={selectedYear}
          passedCalcs={monthlyCalcs?.you}
        />
        {compareWith === 'Default:None' ? null : (
          <CommonSizeArrowsHelper
            cssClass=""
            display="monthly"
            youTotRev={monthlyCalcs?.you?.total_revenue?.[selectedYear]}
            youTotAssets={monthlyCalcs?.you?.total_assets?.[selectedYear]}
            arrayYou={valueArr}
            arrayCompareTo={compareValueArr}
            keyArrBuilder={key}
            monthsAvailable={monthsAvailable}
            selectedYear={compareSelectedYear}
            passedCalcs={passedCalcs}
            pdf={props.pdf}
            sheet={sheet}
            style={valueStyle}
          />
        )}
        {(compareWith && compareWith.includes('Forecast')) || (finalFilters.report_period === 'Trailing 12') ? (
          <Total array={compareValueArr} style={valueStyle} sheet={sheet} />
        ) : null}
        {compareWith === 'Default:None' ? null : (
          <MonthlyCommonSized
            array={compareValueArr}
            metricKey={key}
            style={valueStyle}
            sheet={sheet}
            selectedYear={compareSelectedYear}
            passedCalcs={passedCalcs}
          />
        )}
      </tr>
    );
  };

  let monthlyRows = [];

  if (sheet === 'pnl' && props.naicsCode && props.naicsCode.startsWith('621')) {
    const healthCareRevenueChildKeys = [
      { key: 'total_revenue_gross_charges', copy: 'Gross Charges' },
      { key: 'total_revenue_adjustments', copy: 'Adjustments' }
    ];

    let existingKey;
    healthCareRevenueChildKeys.forEach((k) => {
      existingKey = rows.find(r => r.key === k.key);
      if (!existingKey) {
        monthlyRows.push(
          buildRow({
            key: k.key,
            copy: k.copy,
            header: false,
            padding: '',
            parentKey: 'total_revenue',
            sheet: 'pnl',
            commonKey: 'revenue',
            alwaysDisplayRow: true,
          }),
        );
      }
    });

    if (!existingKey) {
      monthlyRows.push(
        buildRow({
          key: 'space_before_revenue',
          copy: '',
          header: false,
          padding: '',
          sheet: 'pnl',
          emptyRow: true,
        }),
      );
    }
  }

  rows.forEach((row, i) => {
    row.i = i;
    monthlyRows.push(buildRow(row));
  });

  const tableID =
    props.page !== 'docs_pnl' ? `${sheet}-monthly-money` : 'docs_pnl-monthy-money';

  const YOYyearDisplay = props.calendarYearEnd ? previousYear : selectedYear;
  const firstTotal = finalFilters.report_period === 'Trailing 12' ? `T12 ${selectedYear}` : 'Total';
  const firstPercent = finalFilters.report_period === 'Trailing 12' ? `You T12 ${selectedYear}` : 'You YTD';
  let secondTotal = null;
  let secondPercent = null;
  if (compareWith && compareWith.includes('Forecast') && finalFilters.report_period !== 'Trailing 12') {
    secondTotal = `${props.monthlyCompareWithTitle} Total`;
    secondPercent = props.monthlyCompareWithTitle;
  } else if (compareWith === 'Default:Peers' && finalFilters.report_period !== 'Trailing 12') {
    secondPercent = 'Peers Avg';
  } else if (
    compareWith === 'Default:YOY' &&
    monthlyCalcs?.you &&
    finalFilters.report_period !== 'Trailing 12'
  ) {
    secondPercent = `YOY ${YOYyearDisplay}`;
  } else if (finalFilters.report_period === 'Trailing 12' && compareWith !== 'Default:None') {
    secondTotal = `T12 ${previousYear}`;
    secondPercent = `T12 ${previousYear}`;
  }

  const buildMonthlyPDF = (pageViewClassName, tableRows, continued = false) => {
    let clientNames = props.realName ? `${props.realName} / ${clientName}` : clientName
    const tabName = (props.tabName || props.title || '').trim().toLowerCase();
    const title = (props.title || '').trim().toLowerCase();
    let reportTitle = tabName.includes(title) ? props.tabName || props.title : `${props.tabName}, ${props.title} Benchmark Report`;
    let naicsCode = finalFilters.code;
    let dataType = finalFilters.datatype;
    let revenueBand = finalFilters.revenue_band;
    let region = finalFilters.region;
    let numOfDocs = finalFilters.number_of_pros || 'All'
    let reportPeriod = finalFilters.report_period;
    const compareParts = finalFilters.compare_with.split(':');
    let compare = compareParts.length > 1 ? compareParts.slice(1).join(':').trim() : finalFilters.compare_with;
    let filtersTitle = props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, # of Doctors: ${numOfDocs}, Report Period: ${reportPeriod}, Compare with: ${compare}` : `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Report Period: ${reportPeriod}, Compare with: ${compare}`;
    const sheetTitle = continued
      ? `${reportTitle} (Continued)`
      : `${reportTitle}`;

    return (
      <div className={pageViewClassName}>
        <div className="report-pdf-landscape">
          <div>
            <div>
              <p className='report-annual-title'>{`${sheetTitle}, ${clientNames}, ${finalFilters.year}`}</p>
              <p className='report-filters-title'>{filtersTitle}</p>
            </div>
            <div className="money-pdf-table-div">
              <table style={{ whiteSpace: 'pre' }} className="money-monthly-pdf-table">
                <thead>
                  <tr key={`${sheet}-months-header-pdf`}>
                    <td />
                    <td>{monthNames[0]}</td>
                    <td>{monthNames[1]}</td>
                    <td>{monthNames[2]}</td>
                    <td>{monthNames[3]}</td>
                    <td>{monthNames[4]}</td>
                    <td>{monthNames[5]}</td>
                    <td>{monthNames[6]}</td>
                    <td>{monthNames[7]}</td>
                    <td>{monthNames[8]}</td>
                    <td>{monthNames[9]}</td>
                    <td>{monthNames[10]}</td>
                    <td>{monthNames[11]}</td>
                    <td style={{ fontWeight: 'bold' }}>{firstTotal}</td>
                    <td className={commonSizeValCellClass}>{firstPercent}</td>
                    <td className={arrowCellClass} />
                    {secondTotal ? <td className="common-size-cell">{secondTotal}</td> : null}
                    {secondPercent ? <td className="common-size-cell">{secondPercent}</td> : null}
                  </tr>
                </thead>
                <tbody>
                  {tableRows}
                  <tr>
                    <td className="footer-cell">
                      <i>{numberCompare}</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              {props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? (
                <p className="doctor-asterisk-note">
                  *The sub-accounts might not add up to total account if details are not provided.
                </p>
              ) : null}
            </div>
          </div>
          <p className="pdf-disclaimer-text">{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
        </div>
      </div>
    );
  };

  const buildMonthlyTable = () => {
    if (props.pdf) {
      const pageViewClass = 'landscape-view';
      const rowLength = monthlyRows.length;

      if (rowLength > 35) {
        const firstPageRows = monthlyRows.slice(0, 35);
        const secondPageRows = monthlyRows.slice(35);
        return (
          <>
            {buildMonthlyPDF(pageViewClass, firstPageRows)}
            {buildMonthlyPDF(pageViewClass, secondPageRows, true)}
          </>
        );
      }
      return buildMonthlyPDF(pageViewClass, monthlyRows);
    }
    return (
      <div className="money-report-card monthly-sheet">
        <div className="money-report-container">
          <table className="monthly-report-table sheets" id={tableID}>
            <thead>
              <tr key={`${props.title}-monthly-header`}>
                {props.page === 'money' ? (
                  <td className="edit-metrics-cell" onClick={() => handleEditMetrics()}>
                    {editMetrics ? (
                      <i className="fa fa-save hide-on-print" style={{ fontSize: '2em' }} />
                    ) : (
                      <i
                        className="fa fa-pencil edit-icon hide-on-print"
                        style={{ fontSize: '2em' }}
                      />
                    )}
                  </td>
                ) : null}
                <td />
                <td>{monthNames[0]}</td>
                <td>{monthNames[1]}</td>
                <td>{monthNames[2]}</td>
                <td>{monthNames[3]}</td>
                <td>{monthNames[4]}</td>
                <td>{monthNames[5]}</td>
                <td>{monthNames[6]}</td>
                <td>{monthNames[7]}</td>
                <td>{monthNames[8]}</td>
                <td>{monthNames[9]}</td>
                <td>{monthNames[10]}</td>
                <td>{monthNames[11]}</td>
                <td style={{ fontWeight: 'bold' }}>{firstTotal}</td>
                <td className="common-size-cell">{firstPercent}</td>
                <td className="common-size-arrow" />
                {secondTotal ? <td className="common-size-cell">{secondTotal}</td> : null}
                {secondPercent ? <td className="common-size-cell">{secondPercent}</td> : null}
              </tr>
            </thead>
            <tbody>{monthlyRows}</tbody>
            <tfoot>
              <tr>
                <td>
                  <i>{numberCompare}</i>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  };

  return buildMonthlyTable();
};

export default MonthlyHistoricTable;
